function doMonthsStartOnSameDay(startDate) {
    const firstDayCurrentMonth = new Date(startDate.getFullYear(), startDate.getMonth(), 1);
    const firstDayNextMonth = new Date(startDate.getFullYear(), startDate.getMonth() + 1, 1);
    const firstPrevMonth = new Date(startDate.getFullYear(), startDate.getMonth() - 1, 1);
    return (firstDayCurrentMonth.getDay() === firstDayNextMonth.getDay() ||
        firstDayCurrentMonth.getDay() === firstPrevMonth.getDay());
}
export default function searchBoxSelectedDates() {
    const baseDate = new Date(new Date().getTime() + 60 * 60 * 24 * 29 * 1000);
    const calculateBaseDate = new Date(baseDate);
    calculateBaseDate.setDate(baseDate.getDate() - baseDate.getDay() + 6);
    const startDate = new Date(calculateBaseDate);
    const endDate = new Date(calculateBaseDate.getTime() + 60 * 60 * 24 * 7 * 1000);
    if (doMonthsStartOnSameDay(startDate))
        return {};
    return { startDate, endDate };
}
